import React from 'react'

import { Field } from 'react-form'

import { Calendar } from 'primereact/calendar'

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForField } from '../../js/validation'

import '../../css/field.css'

// this ia wrapper function for the prime react calendar component so it can work with react-form's form object
// make sure it is used with Form tags
// this allows the value of the form to be read and updated in the form

// the reason this is done is because prime react's components are examples of controlled components
// they have a value set that binds to the state or props so that when that state or props is updated the component is re-rendered
// the onChange of the component needs to be handled to update the value of the state or props otherwise the user input will not be picked up
// use react-form's setValue function will update the state of the field on the form so that changes will be reflected

// pass in the field as the property name to bind to and the label as what is displayed
// showAsTextOnly is used to disable the component, hide the component styling and make it look like text only
/*
  <Form>
  {formApi => {
    return (
      <form>
        <div className=""p-grid">
          <div className="p-g-6">
            <FieldCalendar field={"StartDate"} label={"Start Date"} validationRules={validationRules} showAsTextOnly={showAsTextOnly}/>
          </div>
        </div>
      </form>
    )}
  }
  </Form>
*/
class FieldCalendar extends React.Component {
  constructor(props) {
    super(props)

    // create reference to calendar component to give more control
    this.calendar = React.createRef()
  }

  // componentDidUpdate() is invoked immediately after updating occurs. This method is not called for the initial render.
  // since we want to call this.messagesList.current.show which will trigger a render we don't want to do it in the render function itself
  componentDidUpdate(prevProps) {
    // this will make sure that the calendar month displayed is based on the value provided or today's date if no value provided
    let previousViewDate= prevProps.viewDate
    let viewDate = this.props.viewDate ? this.props.viewDate : new Date()

    // only display message if the response has changed and there is a response
    if (previousViewDate !== viewDate) {
      // shouldn't need to set state like this but using the clear function on the primereact component doesn't allow
      // something to be called once the state has been set to clear the messages so what was happening was that the messages
      // still existed when showing the new message so nothing gets cleared
      this.calendar.current.setState({
        viewDate: viewDate
      })
    }
  }

  render() {
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
    }
    return (
      // Use the form field and your custom input together to create your very own input!
      // field is the property name that is bound to in the form
      // validate is a function used to validate the field
      <Field field={this.props.field} validate={this.validate}>
        {fieldApi => {
          // fieldApi properties can found at https://react-form.js.org/#/custom-input
          // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
          // this extracts things out of the props passed in and leaves ...rest to be the rest of the properties
          // this way can pass in the extra properties to the prime react component
          const { onBlur, onChange, validate, field, validationRules, showAsTextOnly, ...rest } = this.props

          // value and setValue read and update value in the form
          const { value, setValue, setTouched, error, warning, success } = fieldApi
           const calendarValue = value
            ? (typeof value === 'string' ? new Date(value) : value)
            : null
          return (
            <div className="p-grid">
              <div className="p-col-12 field-label-container">
                <label>
                  {this.props.label}
                  {validationRule && validationRule.IsRequired === false && <span className="optional-field"> - Optional</span>}
                </label>
              </div>
              <div className="p-col-12 field-element-container">
                <Calendar {...rest} value={calendarValue}
                  ref={this.calendar}
                  dateFormat="dd/mm/yy"
                  className={showAsTextOnly ? 'show-text-only' : ''}
                  disabled={showAsTextOnly || rest.disabled}
                  onChange={e => {
                    if (onChange) { onChange(e) }
                    setValue(e.value)
                  }}
                  onBlur={e => {
                    setTouched()
                    if (onBlur) {
                      onBlur(e)
                    }
                  }}
                />
              </div>
              {error ? <FieldMessage color="red" message={error} /> : null}
              {!error && warning ? <FieldMessage color="orange" message={warning} /> : null}
              {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
            </div>
          )
        }}
      </Field>
    )
  }

  /*
    generic validation handler for input field
    checks the validation rules
    TODO - optional validation passed in as a props
  */
  validate = value => {
    let validationResult = {}
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
      if (validationRule) {
        validationResult = validateFromRule(validationRule, value)
      }
    } else {
      validationResult.success = ''
    }
    return validationResult
  }

}
export default FieldCalendar



// WEBPACK FOOTER //
// ./src/components/common/FieldCalendar.js